<div class="wrapper header-border sticky">
	<div class="my-container" *ngIf="true || commonHeader; else landingHeader">
		<div class="header">
			<div class="column hover" (click)="redirectToUserDashBoard()">
				<img src="{{imagePath}}/logo-header.png" alt="" class="logo" *ngIf="User.isHeaderIconIsShow">
				<img src="{{orgImagePath}}" alt="" class="logo" style="padding-left: 5px;">
			</div>
			<div class="column" #headerSecondColumnElement>
				<ul class="navigation">
					<!-- <li>
						<a>BOOKING</a>
						<div class="submenu submenu-navigation">
							<ul>
								<li><a [routerLink]="['/API/inspedit/edit-booking']">New</a></li>
								<li><a [routerLink]="['/API/inspsummary/booking-summary']">Search</a></li>
								<li><a [routerLink]="['/API/schedule/schedule-summary']">Schedule</a></li>
							</ul>
						</div>
					</li>
					<li>
						<a>REPORTS</a>
						<div class="submenu submenu-navigation">
							<ul>
								<li><a [routerLink]="['/API/reportsummary/report-summary']">Filling</a></li>
								<li><a [routerLink]="['/API/report/customer-report']">Download</a></li>
							</ul>
						</div>
					</li>
					<li>
						<a>STATISTICS</a>
						<div class="submenu submenu-navigation">
							<ul>
								<li><a [routerLink]="['/API/defect/dashboard']">Defect</a></li>
								<li><a [routerLink]="['/API/reject/dashboard']">Rejection</a></li>
								<li><a [routerLink]="['/API/quantitativedashboard/dashboard']">Quantitative</a></li>
							</ul>
						</div>
					</li>
					<li>
						<a>MASTER</a>
						<div class="submenu submenu-navigation">
							<ul>
								<li><a [routerLink]="['/API/cussearch/customer-summary']">Customer</a></li>
								<li><a [routerLink]="['/API/suppliersearch/supplier-summary']">Supplier</a></li>
							</ul>
						</div>
					</li> -->
					<!-- <li>
						<a>ADMIN</a>
						<div class="submenu submenu-navigation">
							<ul>
								<li>
									<a>PACKAGE MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/subscriptionedit/new-subscription']">PACKAGE ADD</a>
										</li>
										<li><a [routerLink]="['/API/subscription/subscription-list']">PACKAGE LIST</a>
										</li>
									</ul>
								</li>
								<li>
									<a>FEATURE MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/featureedit/new-feature']">FEATURE ADD</a></li>
										<li><a [routerLink]="['/API/feature/feature-list']">FEATURE LIST</a></li>
									</ul>
								</li>
								<li>
									<a>RIGHT MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/rightedit/new-right']">RIGHT ADD</a></li>
										<li><a [routerLink]="['/API/rightsearch/right-summary']">SEARCH</a></li>
									</ul>
								</li>
								<li>
									<a>ROLE MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/roleedit/new-role']">ROLE ADD</a></li>
										<li><a [routerLink]="['/API/rolesearch/role-summary']">SEARCH</a></li>
									</ul>
								</li>
								<li>
									<a>PERMISSION FEATURE MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/permissionfeatureedit/new-permissionfeature']">PERMISSION
												FEATURE ADD</a></li>
										<li><a
												[routerLink]="['/API/permissionfeaturesearch/permissionfeature-summary']">SEARCH</a>
										</li>
									</ul>
								</li>
								<li>
									<a>TENANT MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/tenantedit/new-tenant']">TENANT ADD</a></li>
										<li><a [routerLink]="['/API/tenantsearch/tenant-summary']">SEARCH</a></li>
									</ul>
								</li>
								<li>
									<a>PERMISSION MAP MANAGEMENT<img src="assets/images/grey-arrow.svg"></a>
									<ul class="submenu level-three">
										<li><a [routerLink]="['/API/permissionmap/permission-map']">PERMISSION MAP</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</li>
					<li>
						<a>TENANT</a>
						<div class="submenu submenu-navigation">
							<ul>
								<li>
									<a [routerLink]="['/API/subscribe']">SUBSCRIBE</a>
									<a [routerLink]="['/API/mysubscription']">MY SUBSCRIPTION</a>
									<a [routerLink]="['/API/company/company-details']">TENANT ADMINISTRATION</a>
								</li>
							</ul>
						</div>
					</li> -->
					<ng-container *ngFor="let subItem of User.rights, let i=index">
						<li *ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length>0">
							<a [routerLinkActive]="['active']">{{subItem.titleName || subItem.menuName}}</a>
							<div class="submenu submenu-navigation">
								<ul
									[ngStyle]="hasManyChildren(subItem.children) ? { 'height': '500px', 'overflow': 'auto' } : {}">
									<ng-container *ngFor="let secondlevelItem of subItem.children">
										<li
											*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length>0">
											<a [routerLinkActive]="['active']">{{secondlevelItem.titleName ||
												secondlevelItem.menuName}}<img src="assets/images/grey-arrow.svg"
													alt=""></a>
											<ul class="submenu level-three">
												<ng-container *ngFor="let thirdlevelitem of secondlevelItem.children">
													<li><a [routerLinkActive]="['active']"
															(click)="getMenuParentId(thirdlevelitem.id)"
															[routerLink]="[geturl(thirdlevelitem)]">{{thirdlevelitem.titleName
															|| thirdlevelitem.menuName}}</a>
													</li>
												</ng-container>
											</ul>
										</li>

										<li
											*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length === 0">
											<ng-container *ngIf="secondlevelItem.isFbLink">
												<a [routerLinkActive]="['active']"
													(onchnages)="getMenuParentId(secondlevelItem.id)" target="_blank"
													[href]="secondlevelItem.path">{{secondlevelItem.titleName ||
													secondlevelItem.menuName}}</a>
											</ng-container>
											<ng-container *ngIf="!secondlevelItem.isFbLink">
												<a [routerLink]="geturl(secondlevelItem)" routerLinkActive="active"
													[class.active]="secondlevelItem.id === activeMenuId"
													(click)="getMenuParentId(secondlevelItem.id)">
													{{ secondlevelItem.titleName || secondlevelItem.menuName }}
												</a>
											</ng-container>
										</li>
									</ng-container>
								</ul>
							</div>
						</li>
						<li
							*ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length === 0">
							<a [routerLinkActive]="['active']" (click)="getMenuParentId(subItem.id)"
								[routerLink]="[geturl(subItem)]">{{subItem.titleName || subItem.menuName}}</a>
						</li>

					</ng-container>
					<!-- <li *ngIf="header != null && header.length > 0"><a><img class="more-menu-icon"
								src="assets/images/cta-more-grey.svg"></a>
						<div class="submenu submenu-navigation">
							<ul>
								<ng-container *ngFor="let subItem of header">
									<li
										*ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length>0">
										<a [routerLinkActive]="['active']">{{subItem.titleName || subItem.menuName}}<img
												src="assets/images/grey-arrow.svg" alt=""></a>

										<div class="submenu-navigation">
											<ul class="submenu level-three">
												<ng-container *ngFor="let secondlevelItem of subItem.children">
													<li
														*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.isHeading && secondlevelItem.children.length>0">
														<a [routerLinkActive]="['active']"
															(click)="toggleAccordion($event)">{{secondlevelItem.titleName || secondlevelItem.menuName}}<img
																src="assets/images/grey-arrow.svg" alt=""></a>													
														<ul class="accordion">
															<ng-container
																*ngFor="let thirdlevelitem of secondlevelItem.children">
																<li><a [routerLinkActive]="['active']"
																		(click)="getMenuParentId(secondlevelItem.id)"
																		[routerLink]="[geturl(thirdlevelitem)]">{{thirdlevelitem.titleName || thirdlevelitem.menuName}}</a>
																</li>
															</ng-container>
														</ul>
													
													</li>
													<li
														*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length==0">
														<a [routerLinkActive]="['active']"
															(click)="getMenuParentId(secondlevelItem.id)"
															[routerLink]="[geturl(secondlevelItem)]">{{secondlevelItem.titleName || secondlevelItem.menuName}}</a>
													</li>
												</ng-container>
											</ul>
										</div>
									</li>
								</ng-container>
							</ul>
						</div>
					</li> -->
					<!-- <li *ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length==0">
						<a [routerLinkActive]="['active']" (click)="getMenuParentId(subItem.id)"
							[routerLink]="[geturl(subItem)]">{{subItem.titleName || subItem.menuName}}</a>
					</li> -->

				</ul>
				<!-- <ul class="navigation">
					<ng-container *ngFor="let subItem of User.rights, let i=index">
						<li
							*ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length>0 && i< _headercount">
							<a [routerLinkActive]="['active']">{{subItem.titleName || subItem.menuName}}</a>
							<div class="submenu submenu-navigation">
								<ul>
									<ng-container *ngFor="let secondlevelItem of subItem.children">
										<li
											*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.isHeading && secondlevelItem.children.length>0">
											<a [routerLinkActive]="['active']">{{secondlevelItem.titleName || secondlevelItem.menuName}}<img
													src="assets/images/grey-arrow.svg" alt=""></a>
											<ul class="submenu level-three">
												<ng-container *ngFor="let thirdlevelitem of secondlevelItem.children">
													<li><a [routerLinkActive]="['active']"
															(click)="getMenuParentId(thirdlevelitem.id)"
															[routerLink]="[geturl(thirdlevelitem)]">{{thirdlevelitem.titleName || thirdlevelitem.menuName}}</a>
													</li>
												</ng-container>
											</ul>
										</li>
										<li
											*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length==0">
											<a [routerLinkActive]="['active']"
												(click)="getMenuParentId(secondlevelItem.id)"
												[routerLink]="[geturl(secondlevelItem)]">{{secondlevelItem.titleName || secondlevelItem.menuName}}</a>
										</li>
									</ng-container>
								</ul>
							</div>
						</li>
						<li
							*ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length==0">
							<a [routerLinkActive]="['active']" (click)="getMenuParentId(subItem.id)"
								[routerLink]="[geturl(subItem)]">{{subItem.titleName || subItem.menuName}}</a>
						</li>

					</ng-container>
					<li *ngIf="header != null && header.length > 0"><a><img class="more-menu-icon"
								src="assets/images/cta-more-grey.svg"></a>
						<div class="submenu submenu-navigation">
							<ul>
								<ng-container *ngFor="let subItem of header">
									<li
										*ngIf="subItem && subItem.parentId==null && subItem.isHeading && subItem.children.length>0">
										<a [routerLinkActive]="['active']">{{subItem.titleName || subItem.menuName}}<img
												src="assets/images/grey-arrow.svg" alt=""></a>

										<div class="submenu-navigation">
											<ul class="submenu level-three">
												<ng-container *ngFor="let secondlevelItem of subItem.children">
													<li
														*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.isHeading && secondlevelItem.children.length>0">
														<a [routerLinkActive]="['active']"
															(click)="toggleAccordion($event)">{{secondlevelItem.titleName || secondlevelItem.menuName}}<img
																src="assets/images/grey-arrow.svg" alt=""></a>
														
														<ul class="accordion">
															<ng-container
																*ngFor="let thirdlevelitem of secondlevelItem.children">
																<li><a [routerLinkActive]="['active']"
																		(click)="getMenuParentId(secondlevelItem.id)"
																		[routerLink]="[geturl(thirdlevelitem)]">{{thirdlevelitem.titleName || thirdlevelitem.menuName}}</a>
																</li>
															</ng-container>
														</ul>
													
													</li>
													<li
														*ngIf="secondlevelItem && secondlevelItem.parentId!=null && secondlevelItem.children.length==0">
														<a [routerLinkActive]="['active']"
															(click)="getMenuParentId(secondlevelItem.id)"
															[routerLink]="[geturl(secondlevelItem)]">{{secondlevelItem.titleName || secondlevelItem.menuName}}</a>
													</li>
												</ng-container>
											</ul>
										</div>
									</li>
								</ng-container>
							</ul>
						</div>
					</li>
				</ul> -->
				<ul class="navigation-second" #headerSecondColumnLastChild>
					<li [ngClass]="{'active': masterModel.showHelpPanel}">
						<span id="helpTrigger" (click)="toggleNotification($event, 'helpContainer')"
							*ngIf="_userTypeId == _customerusertype || User.isSupportIconIsShow">
							<img src="assets/images/header-help.svg" class="mobile-nav-child">
						</span>
						<div class="submenu submenu-help" [ngClass]="{'active': masterModel.showHelpPanel}"
							id="helpContainer">
							<div class="first-section">
								<h4 class="title">{{ 'HEADER.LBL_HEADER_HELP_YOU' | translate }}</h4>
								<p class="subtitle">{{ 'HEADER.LBL_HEADER_PLEASE_CONTACT_US' | translate }}
								</p>
								<!-- <button class="secondary-cta small" (click)="openEmailWindow()">{{
									'HEADER.LBL_SEND_QUERY' | translate }}</button> -->

								<button id="myCustomTrigger" class="secondary-cta small"
									(click)="loadJiraCollectorScript()">
									{{ 'HEADER.LBL_SEND_QUERY' | translate }}</button>
								<div class="help-card">
									<img src="assets/images/user.svg" alt="" class="icon">
									<!--If user type is customer-->
									<!-- <div class="content" *ngIf="User.usertype == _userType.Customer">
										<h4 class="card-title">{{ customerKAMDetail.name }}</h4>
										<p class="card-subtitle">{{ 'HEADER.LBL_CUSTOMER_SERVICE_EXECUTIVE' | translate
											}}</p>
										<p class="card-contact-info">{{ customerKAMDetail.email }}</p>
										<p class="card-contact-info">{{ customerKAMDetail.phoneNumber }}</p>
									</div>
									 -->
									<!--If user type is supplier or factory-->
									<div class="content">
										<h4 class="card-title">{{ 'HEADER.LBL_SERVICE_DESK' | translate }}</h4>
										<p class="card-subtitle" style="margin-top: 10px;">{{
											'HEADER.LBL_SUPPLIER_PLS_SEND_EMAIL' | translate }}
										</p>
										<p class="card-contact-info">{{ itSupporEmail }}</p>
									</div>
								</div>
							</div>
							<div class="support-list" *ngIf="isUserGuideAccess" (click)="redirectUserManual()">
								<div class="icon">
									<img src="assets/images/download-manual.svg" alt="">
								</div>
								<div class="content">
									<h4 class="support-title">
										<a>{{ 'USER_GUIDE.LBL_DOWNLOAD_USER_MANUAL' | translate }}</a>
									</h4>
									<h5 class="support-subtitle">{{ 'USER_GUIDE.LBL_REFER_USER_MANUAL' | translate }}
									</h5>
								</div>
							</div>
						</div>
					</li>
					<li [ngClass]="{'active': masterModel.showTaskPanel}">
						<span id="taskTrigger" (click)="toggleNotification($event, 'taskContainer')">
							<img src="assets/images/header-task.svg" alt="task" class="mobile-nav-child notification">
							<span class="notification-count">{{getCountForDisplay(masterModel.taskTotalCount)}}</span>
						</span>
						<div class="submenu new-submenu-notification" [ngClass]="{'active': masterModel.showTaskPanel}"
							id="taskContainer">
							<div class="submenu-head">
								<div class="title-container">
									<span class="title">{{ 'HEADER.LBL_TASK' | translate }}</span>
									<div class="dropdown-wrapper">
										{{ 'HEADER.LBL_FILTER_BY' | translate }} :
										<ng-select #ngTaskSelectComponent id="taskDropdown"
											class="new-small no-margin width-120" [clearOnBackspace]="true"
											[searchable]="true" [hideSelected]="true" [items]="masterModel.taskTypeList"
											bindLabel="name" bindValue="id" (change)="changeTaskType($event)"
											placeholder="All task">
										</ng-select>
										<!-- <select>
											<option *ngFor="let taskTypeList of masterModel.taskTypeList">{{taskTypeList?.name}}</option>
										</select> -->
										<div class="filter-cta style-2 has-dropdown">
											<img src="assets/images/three-dots.svg" alt="">
											<ul class="cta-dropdown bottom-left no-scroll">
												<!-- <li>  [items]="masterModel.taskTypeList" (change)="changeTaskType($event)"
                                                    <img src="assets/images/new-set/cta-read-mark.svg" alt="" class="icon">
                                                    <span (click)="allDoneTask()">{{'HEADER.LBL_TASK_MARK_ALL_AS_DONE' | translate}}</span>
                                                </li> -->
												<li>
													<img src="assets/images/new-set/cta-read-mark.svg" alt=""
														class="icon">
													<span (click)="clearAllTask()">{{'HEADER.LBL_RESET_FILTER' |
														translate}}</span>
												</li>
											</ul>
										</div>
										<img class="close-icon" src="assets/images/new-set/close.svg" alt="">
									</div>
								</div>
								<span class="">{{'HEADER.LBL_YOU_HAVE'| translate}}
									{{'HEADER.LBL_PENDING_TASK'|translate}}
									{{'HEADER.LBL_TASK'|translate}}</span>
							</div>
							<div class="submenu-body" (scroll)="onScroll($event,'taskContainer')">

								<div class="notification-wrapper" *ngIf="masterModel.todayTaskList?.length != 0">
									<span class="day-count">{{'HEADER.LBL_TODAY'| translate}}
										({{masterModel.taskCount.todayCount}})</span>
									<ul>
										<li *ngFor="let item of masterModel.todayTaskList">
											<div class="notification-item">
												<div class="item-body" (click)="navigateTaskPage(item)">
													<div *ngIf="!item.task.isDone" class="green-dot"></div>
													<div *ngIf="item.task.isDone" class="green-dot empty"></div>
													<img class="notification-icon"
														[ngClass]="getCustomhightWidth(item.task.type)"
														src="assets/images/new-set/{{item.iconName}}" alt="">
													<div class="heading-container">
														<span class="heading">{{item.task.typeLable}}</span>
														<span class="sub-heading">{{item.message}}</span>
													</div>
												</div>
												<div>
													<span class="task-time">{{item.task.createdOn |utcToLocalTime |
														date:'shortTime'}}</span>
													<!-- <ul class="cta-dropdown bottom-left no-scroll" *ngIf="!item.task.isDone">
                                                        <li>class="has-dropdown"
                                                            <img src="assets/images/new-set/cta-read-mark.svg" alt="" class="icon">
                                                            <span (click)="doneTask(item.link, item.task.id)">{{'HEADER.LBL_TASK_MARK_AS_DONE'|translate}}</span>
                                                        </li>
                                                    </ul> -->
												</div>
											</div>
										</li>
									</ul>
								</div>
								<div class="notification-wrapper" *ngIf="masterModel.yesterdayTaskList?.length != 0">
									<span class="day-count">{{'HEADER.LBL_YESTERDAY'| translate}}
										({{masterModel.taskCount.yesterdayCount}})</span>
									<ul>
										<li *ngFor="let item of masterModel.yesterdayTaskList">
											<div class="notification-item">
												<div class="item-body" (click)="navigateTaskPage(item)">
													<div *ngIf="!item.task.isDone" class="green-dot"></div>
													<div *ngIf="item.task.isDone" class="green-dot empty"></div>
													<img class="notification-icon"
														[ngClass]="getCustomhightWidth(item.task.type)"
														src="assets/images/new-set/{{item.iconName}}" alt="">
													<div class="heading-container">
														<span class="heading">{{item.task.typeLable}}</span>
														<span class="sub-heading">{{item.message}}</span>
													</div>
												</div>
												<div>
													<span class="task-time">{{item.task.createdOn |utcToLocalTime |
														date:'shortTime'}}</span>
													<!-- <ul class="cta-dropdown bottom-left no-scroll" *ngIf="!item.task.isDone">
                                                        <li>
                                                            <img src="assets/images/new-set/cta-read-mark.svg" alt="" class="icon">
                                                            <span (click)="doneTask(item.link, item.task.id)">{{'HEADER.LBL_TASK_MARK_AS_DONE'|translate}}</span>
                                                        </li>
                                                    </ul> -->
												</div>
											</div>
										</li>
									</ul>
								</div>
								<div class="notification-wrapper" *ngIf="masterModel.olderTaskList?.length != 0">
									<span class="day-count">{{'HEADER.LBL_OLDER'| translate}}
										({{masterModel.taskCount.olderCount}})</span>
									<ul>
										<li *ngFor="let item of masterModel.olderTaskList">
											<div class="notification-item">
												<div class="item-body" (click)="navigateTaskPage(item)">
													<div *ngIf="!item.task.isDone" class="green-dot"></div>
													<div *ngIf="item.task.isDone" class="green-dot empty"></div>
													<img class="notification-icon"
														[ngClass]="getCustomhightWidth(item.task.type)"
														src="assets/images/new-set/{{item.iconName}}" alt="">
													<div class="heading-container">
														<span class="heading">{{item.task.typeLable}}</span>
														<span class="sub-heading">{{item.message}}</span>
													</div>
												</div>
												<div>
													<span class="task-time">{{item.task.createdOn | utcToLocalTime |
														date:standardOnlyDateFormat}}</span>
													<!-- <ul class="cta-dropdown bottom-left no-scroll" *ngIf="!item.task.isDone">
                                                        <li>
                                                            <img src="assets/images/new-set/cta-read-mark.svg" alt="" class="icon">
                                                            <span (click)="doneTask(item.link, item.task.id)">{{'HEADER.LBL_TASK_MARK_AS_DONE'|translate}}</span>
                                                        </li>
                                                    </ul> -->
												</div>
											</div>
										</li>
									</ul>
								</div>
								<div class="notification-placeholder-container mt-3" *ngIf="masterModel.taskLoader">
									<ul>
										<li>
											<div class="row">
												<div class="col-lg-2">
													<div class="rect-common animate notification-cirle"></div>
												</div>
												<div class="col-lg-6">
													<div class="rect-common animate height36"></div>
												</div>
												<div class="col-lg-2"></div>
												<div class="col-lg-2">
													<div class="rect-common animate height36"></div>
												</div>
											</div>
										</li>
										<li>
											<div class="row">
												<div class="col-lg-2">
													<div class="rect-common animate notification-cirle"></div>
												</div>
												<div class="col-lg-6">
													<div class="rect-common animate height36"></div>
												</div>
												<div class="col-lg-2"></div>
												<div class="col-lg-2">
													<div class="rect-common animate height36"></div>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</li>
					<li [ngClass]="{'active': masterModel.showNotificationPanel}">
						<span id="notificationTrigger" (click)="toggleNotification($event, 'notificationContainer')">
							<img src="assets/images/header-bell.svg" alt="notification"
								class="mobile-nav-child notification">
							<span
								class="notification-count">{{getCountForDisplay(masterModel.notifiactionTotalCount)}}</span>
						</span>
						<div class="submenu new-submenu-notification"
							[ngClass]="{'active': masterModel.showNotificationPanel}" id="notificationContainer">
							<div class="submenu-head">
								<div class="title-container">
									<span class="title">{{ 'HEADER.LBL_NOTIFICATION' | translate }}</span>
									<div class="dropdown-wrapper">
										{{ 'HEADER.LBL_FILTER_BY' | translate }} :
										<ng-select #ngNotificationSelectComponent id="notificationDropdown"
											class="new-small no-margin width-120" [clearOnBackspace]="true"
											[searchable]="true" [hideSelected]="true"
											[items]="masterModel.notificationTypeList" bindLabel="name" bindValue="id"
											(change)="changeNotificationType($event)" placeholder="All notification">
										</ng-select>
										<div class="filter-cta style-2 has-dropdown">
											<img src="assets/images/three-dots.svg" alt="">
											<ul class="cta-dropdown bottom-left no-scroll">
												<li>
													<img src="assets/images/new-set/cta-read-mark.svg" alt=""
														class="icon">
													<span
														(click)="readAllNotification()">{{'HEADER.LBL_NOTIFICATION_MARK_ALL_AS_READ'
														| translate}}</span>
												</li>
												<li>
													<img src="assets/images/new-set/cta-read-mark.svg" alt=""
														class="icon">
													<span (click)="clearAllNotification()">{{'HEADER.LBL_RESET_FILTER' |
														translate}}</span>
												</li>
											</ul>
										</div>
										<img class="close-icon" src="assets/images/new-set/close.svg" alt="">
									</div>
								</div>
								<span class="">{{'HEADER.LBL_YOU_HAVE'| translate}} <span class="mark-read"
										(click)="getReadNotification()">{{getNotificationStatus()}}</span>
									{{'HEADER.LBL_NOTIFICATIONS'|translate}}</span>
							</div>
							<div class="submenu-body" (scroll)="onScroll($event,'notificationContainer')">

								<div class="notification-wrapper"
									*ngIf="masterModel.todayNotificationList?.length != 0">
									<span class="day-count">{{'HEADER.LBL_TODAY'| translate}}
										({{masterModel.notificationCount.todayCount}})</span>
									<ul>
										<li *ngFor="let item of masterModel.todayNotificationList">

											<div class="notification-item">
												<div class="item-body" (click)="navigateNotificationPage(item)">
													<div *ngIf="!item.notification.isRead" class="green-dot"></div>
													<div *ngIf="item.notification.isRead" class="green-dot empty"></div>
													<img class="notification-icon"
														[ngClass]="getNotificationCustomhightWidth(item.notification.type)"
														src="assets/images/new-set/{{item.iconName}}" alt="">
													<div class="heading-container">
														<span class="heading">{{item.notification.typeLabel}}</span>
														<span class="sub-heading">{{item.message}}</span>
													</div>
												</div>
												<div class="has-dropdown">
													<span class="time">{{item.notification.createdOn | utcToLocalTime |
														date:'shortTime'}}</span>
													<ul class="cta-dropdown bottom-left no-scroll"
														*ngIf="!item.notification.isRead">
														<li>
															<img src="assets/images/new-set/cta-read-mark.svg" alt=""
																class="icon">
															<span
																(click)="getNotificationDetail(item)">{{'HEADER.LBL_NOTIFICATION_MARK_AS_READ'|translate}}</span>
														</li>
													</ul>
												</div>
											</div>
										</li>
									</ul>
								</div>
								<div class="notification-wrapper"
									*ngIf="masterModel.yesterdayNotificationList?.length != 0">
									<span class="day-count">{{'HEADER.LBL_YESTERDAY'| translate}}
										({{masterModel.notificationCount.yesterdayCount}})</span>
									<ul>
										<li *ngFor="let item of masterModel.yesterdayNotificationList">
											<div class="notification-item">
												<div class="item-body" (click)="navigateNotificationPage(item)">
													<div *ngIf="!item.notification.isRead" class="green-dot"></div>
													<div *ngIf="item.notification.isRead" class="green-dot empty"></div>
													<img class="notification-icon"
														[ngClass]="getNotificationCustomhightWidth(item.notification.type)"
														src="assets/images/new-set/{{item.iconName}}" alt="">
													<div class="heading-container">
														<span class="heading">{{item.notification.typeLabel}}</span>
														<span class="sub-heading">{{item.message}}</span>
													</div>
												</div>
												<div class="has-dropdown">
													<span class="time">{{item.notification.createdOn | utcToLocalTime |
														date:'shortTime'}}</span>
													<ul class="cta-dropdown bottom-left no-scroll"
														*ngIf="!item.notification.isRead">
														<li>
															<img src="assets/images/new-set/cta-read-mark.svg" alt=""
																class="icon">
															<span
																(click)="getNotificationDetail(item)">{{'HEADER.LBL_NOTIFICATION_MARK_AS_READ'|translate}}</span>
														</li>
													</ul>
												</div>
											</div>
										</li>
									</ul>
								</div>
								<div class="notification-wrapper"
									*ngIf="masterModel.olderNotificationList?.length != 0">
									<span class="day-count">{{'HEADER.LBL_OLDER'| translate}}
										({{masterModel.notificationCount.olderCount}})</span>
									<ul>
										<li *ngFor="let item of masterModel.olderNotificationList">
											<div class="notification-item">
												<div class="item-body" (click)="navigateNotificationPage(item)">
													<div *ngIf="!item.notification.isRead" class="green-dot"></div>
													<div *ngIf="item.notification.isRead" class="green-dot empty"></div>
													<img class="notification-icon"
														[ngClass]="getNotificationCustomhightWidth(item.notification.type)"
														src="assets/images/new-set/{{item.iconName}}" alt="">
													<div class="heading-container">
														<span class="heading">{{item.notification.typeLabel}}</span>
														<span class="sub-heading">{{item.message}}</span>
													</div>
												</div>
												<div class="has-dropdown">
													<span class="time">{{item.notification.createdOn | utcToLocalTime |
														date:standardOnlyDateFormat}}</span>
													<ul class="cta-dropdown bottom-left no-scroll"
														*ngIf="!item.notification.isRead">
														<li>
															<img src="assets/images/new-set/cta-read-mark.svg" alt=""
																class="icon">
															<span
																(click)="getNotificationDetail(item)">{{'HEADER.LBL_NOTIFICATION_MARK_AS_READ'|translate}}</span>
														</li>
													</ul>
												</div>
											</div>
										</li>
									</ul>
								</div>
								<div class="notification-placeholder-container mt-3"
									*ngIf="masterModel.notifiactionLoader">
									<ul>
										<li>
											<div class="row">
												<div class="col-lg-2">
													<div class="rect-common animate notification-cirle"></div>
												</div>
												<div class="col-lg-6">
													<div class="rect-common animate height36"></div>
												</div>
												<div class="col-lg-2"></div>
												<div class="col-lg-2">
													<div class="rect-common animate height36"></div>
												</div>
											</div>
										</li>
										<li>
											<div class="row">
												<div class="col-lg-2">
													<div class="rect-common animate notification-cirle"></div>
												</div>
												<div class="col-lg-6">
													<div class="rect-common animate height36"></div>
												</div>
												<div class="col-lg-2"></div>
												<div class="col-lg-2">
													<div class="rect-common animate height36"></div>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</li>
					<!-- <li>
						<img src="assets/images/header-task.svg" click="toggleNotification($event, 'taskContainer')" alt="notification" class="mobile-nav-child">
						<span class="notification-count">{{masterModel.taskTotalCount}}</span>
						<div class="submenu submenu-notification">
							<div class="submenu-head">
								<span class="title">{{ 'HEADER.LBL_TASK' | translate }} </span>
								<span class="mark-read"></span>
							</div>
							<ul>
								<li *ngFor="let item of headerService.taskList"><a [href]="[item.link]"><img
											src="assets/images/{{item.iconName}}" alt="icon"
											class="icon">{{item.message}}</a></li>
								<li *ngIf="headerService.taskList == null || headerService.taskList.length == 0"><a
										href="#"><img src="assets/images/black-file.svg" alt="icon" class="icon">{{
										'HEADER.MSG_NO_TASK' | translate }}</a></li>
							</ul>
							 <div class="submenu-footer">
							</div> 
						</div>
					</li> -->
					<!-- <li>
						<img src="assets/images/header-bell.svg" alt="notification"
							class="mobile-nav-child notification">
						<span class="notification-count">{{notificationList ? notificationList.length : 0}}</span>
						<div class="submenu submenu-notification">
							<div class="submenu-head">
								<span class="title">{{ 'HEADER.LBL_NOTIFICATION' | translate }}</span>
								<span class="mark-read"></span>
							</div>
							<ul>
								<li *ngFor="let item of notificationList"><a
										(click)="getNotificationDetail(item.link, item.notification.id)">{{item.message}}</a>
								</li>
								<li *ngIf="notificationList == null || notificationList.length == 0"><a href="#">{{
										'HEADER.MSG_NO_NOTIFICATION' | translate }}</a>
							</ul>
							<div class="submenu-footer">
								</div> -->
					<!-- </div>
					</li> -->
					<li class="last">
						<div class="user-info">
							<img src="{{userProfileImage}}" alt="user" class="user-thumb">
							<div class="info-text">

								<p class="text">{{User.fullName}}</p>
							</div>
							<img src="{{imagePath}}/grey-arrow.svg" alt="" class="drop-icon">
						</div>
						<img src="assets/images/hamburger.svg" (click)="openHamburger()" alt="hamburger"
							class="hamburger">
						<div class="submenu device-hide last-dropdown">
							<ul>
								<!-- <li>
									<a [routerLink]="['/api/changepassword']">
										<img src="assets/images/setting.svg" alt="settings" class="icon">{{
										'HEADER.LBL_CHANGEPASSWD' | translate }}</a>
								</li> -->

								<li *ngIf="isChangePasswordAccess">
									<a [routerLink]="['/changepassword']">
										<img src="assets/images/new-set/edit-dark.svg" alt="password" class="icon">{{
										'HEADER.LBL_CHANGEPASSWD' | translate }}</a>
								</li>

								<li *ngIf="_userTypeId != _internalusertype"><a (click)="redirectToProfilePage()"><img
											src="assets/images/user.svg" alt="profile" class="icon">{{
										'USER_PROFILE.TITLE' | translate }}</a></li>
								<li><a (click)="signOut()"><img src="assets/images/logout.svg" alt="logout"
											class="icon">{{ 'HEADER.LBL_SIGNOUT' | translate }}</a></li>
								<!-- <ng-container *ngIf="User.routes.includes(router.url)">
									<li class="seperator theme-heading">{{'HEADER.LBL_APPEARANCE' | translate}}</li>
									<li class="theme-control">
										<a href="">
											<div class="styled-radio-container">
												<input type="radio" value="1" class="styled-radio" id="test1"
													name="radio-group" [checked]="hasDarkTheme === false"
													(change)="themeChange($event)">
												<label for="test1">{{'HEADER.LBL_LIGHT_MODE' | translate}}<img
														src="assets/images/new-set/light-mode.svg" alt=""
														class="theme-icon"></label>
											</div>
										</a>
									</li>
									<li class="theme-control">
										<a href="">
											<div class="styled-radio-container">
												<input type="radio" value="2" class="styled-radio" id="test2"
													name="radio-group" [checked]="hasDarkTheme === true"
													(change)="themeChange($event)">
												<label for="test2">{{'HEADER.LBL_DARK_MODE' | translate}}<img
														src="assets/images/new-set/dark-mode.svg" alt=""
														class="theme-icon"></label>
											</div>
										</a>
									</li>
								</ng-container> -->
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<ng-template #landingHeader>
		<div class="my-container landing-container">
			<div class="header">
				<div class="column"></div>
				<div class="column">
					<ul class="navigation-second">
						<li class="product-dropdown-wrapper">
							<ng-select [items]="products" bindLabel="name" bindValue="id" [clearable]="false"
								placeholder="Select" [searchable]="false" [ngModel]="selectedProduct">
								<ng-template ng-label-tmp let-item="item">
									<img src="assets/images/{{item.name}}" class="logo-image" alt="">
								</ng-template>
								<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
									<img src="assets/images/{{item.name}}" class="logo-image" alt="">
								</ng-template>
							</ng-select>
						</li>
						<!-- <li class="product-dropdown-wrapper">
							<div class="selected-product">
								<img class="logo" src="assets/images/sgt-small.svg" alt="">
							</div>
							<div class="produc-dropdown-container">
								<div><img src="assets/images/sgt-small.svg" alt=""></div>
								<div><img src="assets/images/api-small.png" alt=""></div>
								<div><img src="assets/images/aqf-small.png" alt=""></div>
							</div>
						</li> -->
						<li class="last">
							<div class="user-info">
								<img src="{{imagePath}}/default-profile.svg" alt="user" class="user-thumb">
								<div class="info-text">
									<p class="text">Thibaut HENNI (STOKOMANI)</p>
								</div>
								<img src="{{imagePath}}/grey-arrow.svg" alt="" class="drop-icon">
							</div>
							<img src="assets/images/hamburger.svg" (click)="openHamburger()" alt="hamburger"
								class="hamburger">
							<div class="submenu device-hide last-dropdown">
								<ul>
									<li><a href="#"><img src="assets/images/setting.svg" alt="settings"
												class="icon">Settings</a></li>
									<li><a href="#"><img src="assets/images/logout.svg" alt="logout"
												class="icon">Logout</a></li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</ng-template>
</div>
<div class="side-navigation-container" [ngClass]="{'opened': expandNavigation}">
	<div class="trigger-container">
		<span class="side-hamburger" *ngIf="expandNavigation">
			<img src="{{imagePath}}/close.svg" alt="" (click)="toggleSidebar()">
		</span>
		<span class="side-hamburger" *ngIf="!expandNavigation">
			<img src="{{imagePath}}/side-hamburger.svg" alt="" (click)="toggleSidebar()">
		</span>
		<div class="logo-container" *ngIf="expandNavigation">
			<img src="{{imagePath}}/logo-header.png" alt="" class="logo" *ngIf="User.isHeaderIconIsShow">
			<img src="{{orgImagePath}}" alt="" class="logo" *ngIf="!User.isHeaderIconIsShow">
		</div>

	</div>
	<ul>
		<ng-container *ngFor="let item of User.packageFeatures">
			<li class="common-tooltip right" *ngIf="!expandNavigation" [attr.data-tooltip]="item.name"
				[ngClass]="{'active' : item.id == selectedId, 'disabled': !item.isActive}"
				(click)="item.isActive ? RedirectWithServiceAccess(item.id, item) : null">
				<img [src]="item.iconPath" alt="">
				<!-- <img *ngIf="!item.isActive" src="{{imagePath}}/inspection-navigation-disabled.svg" alt=""> -->
				<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">{{item.name}}</p>
			</li>

			<li *ngIf="expandNavigation" [ngClass]="{'active' : item.id == selectedId, 'disabled': !item.isActive}"
				(click)="item.isActive ? RedirectWithServiceAccess(item.id, item) : null">
				<img [src]="item.iconPath" alt="">
				<!-- <img *ngIf="!item.isActive" src="{{imagePath}}/inspection-navigation-disabled.svg" alt=""> -->
				<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">{{item.name}}</p>
			</li>
		</ng-container>
	</ul>
</div>

<!-- 
<div class="side-navigation-container" [ngClass]="{'opened': expandNavigation}">
	<div class="trigger-container">
		<span class="side-hamburger" *ngIf="expandNavigation">
			<img src="{{imagePath}}/close.svg" alt="" (click)="toggleSidebar()">
		</span>
		<span class="side-hamburger" *ngIf="!expandNavigation">
			<img src="{{imagePath}}/side-hamburger.svg" alt="" (click)="toggleSidebar()">
		</span>
		<div class="logo-container" *ngIf="expandNavigation">
			<img src="{{imagePath}}/logo-header.png" alt="" class="logo">
		</div>
	</div>
	<ul>

		<ng-container *ngFor="let item of User.packageFeatures">
			<li class="common-tooltip right" [attr.data-tooltip]="item.name"
			[ngClass]="{'active' : item.id == selectedId, 'disabled': !item.isActive}"
			(click)="RedirectWithServiceAccess(item.id)">
				<img *ngIf="true" [src]="item.iconPath" alt="">
				<img *ngIf="false" src="{{imagePath}}/inspection-navigation-disabled.svg" alt="">
				<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">{{item.name}}</p>
			</li>
		</ng-container>
	</ul>
</div> -->



<!-- <li class="common-tooltip right" data-tooltip="Inspection">
			<img *ngIf="true" src="assets/images/new-set/inspection-navigation.svg" alt="">
			<img *ngIf="false" src="assets/images/new-set/inspection-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Inspection</p>
		</li>
		<li class="common-tooltip right" data-tooltip="Audit">
			<img *ngIf="true" src="assets/images/new-set/audit-navigation.svg" alt="">
			<img *ngIf="false" src="assets/images/new-set/audit-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Audit</p>
		</li>
		<li class="common-tooltip right" data-tooltip="Analytics">
			<img *ngIf="true" src="assets/images/new-set/analytic-navigation.svg" alt="">
			<img *ngIf="false" src="assets/images/new-set/analytic-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Analytics</p>
		</li>
		<li class="common-tooltip right" data-tooltip="I - TCF">
			<img *ngIf="true" src="assets/images/new-set/tcf-navigation.svg" alt="">
			<img *ngIf="false" src="assets/images/new-set/tcf-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">I - TCF</p>
		</li>
		<li class="common-tooltip right" data-tooltip="Lab Testing">
			<img *ngIf="true" src="assets/images/new-set/lab-navigation.svg" alt="">
			<img *ngIf="false" src="assets/images/new-set/lab-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Lab Testing</p>
		</li>
		<li class="common-tooltip right" data-tooltip="Data Management">
			<img *ngIf="true" src="assets/images/new-set/data-navigation.svg" alt="">
			<img *ngIf="false" src="assets/images/new-set/data-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Data Management</p>
		</li>
		<li>
			<img *ngIf="false" src="assets/images/new-set/tracing-navigation.svg" alt="">
			<img *ngIf="true" src="assets/images/new-set/tracing-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Tracebility</p>
			<img class="enable-icon" src="assets/images/new-set/navigation-enable.svg" alt="">
		</li>
		<li>
			<img *ngIf="false" src="assets/images/new-set/plm-navigation.svg" alt="">
			<img *ngIf="true" src="assets/images/new-set/plm-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">PLM</p>
			<img class="enable-icon" src="assets/images/new-set/navigation-enable.svg" alt="">
		</li>
		<li>
			<img *ngIf="false" src="assets/images/new-set/compliance-navigation.svg" alt="">
			<img *ngIf="true" src="assets/images/new-set/compliance-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Compliance</p>
			<img class="enable-icon" src="assets/images/new-set/navigation-enable.svg" alt="">
		</li>
		<li>
			<img *ngIf="false" src="assets/images/new-set/academy-navigation.svg" alt="">
			<img *ngIf="true" src="assets/images/new-set/academy-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Academy</p>
			<img class="enable-icon" src="assets/images/new-set/navigation-enable.svg" alt="">
		</li>
		<li>
			<img *ngIf="false" src="assets/images/new-set/sustain-navigation.svg" alt="">
			<img *ngIf="true" src="assets/images/new-set/sustain-navigation-disabled.svg" alt="">
			<p [@expandCollapse]="expandNavigation ? 'open' : 'close'">Sustainability</p>
			<img class="enable-icon" src="assets/images/new-set/navigation-enable.svg" alt="">
		</li> -->
<!-- </ul> 
</div> -->